export const VALIDATION_MSG = {
    EMAIL: 'Invalid email address'
};
